const initialTaskFirstPerson = {
  firstName: 'Ranjani',
  lastName: 'Shettar',
  score: 10,
};

export { initialTaskFirstPerson };
